import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import { initCounters } from '../components/counter';

/*
 * Hero metrics count up when they enter the viewport
 */
initCounters('.tbn-metric__value .js-counter');

/*
 * Partners Logos Swiper
 * Infinite smooth autoplay carousel
 */
const partnersSwiper = document.querySelector('.tbn-partners-swiper');
if (partnersSwiper) {
	// eslint-disable-next-line no-new
	new Swiper('.tbn-partners-swiper', {
		modules: [Autoplay],
		slidesPerView: 2,
		spaceBetween: 20,
		loop: true,
		loopAdditionalSlides: 5,
		speed: 7000,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
		allowTouchMove: true,
		freeMode: {
			enabled: true,
			momentum: false,
		},
		breakpoints: {
			576: {
				slidesPerView: 3,
			},
			768: {
				slidesPerView: 4,
			},
			992: {
				slidesPerView: 5,
			},
		},
	});
}

/*
 * Discovery cards cascade in when the section scrolls into view
 */
const discovery = document.querySelector('.tbn-discovery');
if (discovery) {
	const revealObserver = new IntersectionObserver(
		(entries, observer) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.classList.add('is-revealed');
					observer.unobserve(entry.target);
				}
			});
		},
		{ threshold: 0.25 },
	);
	revealObserver.observe(discovery);
}

const slider = document.querySelector('.tbn-slider');

if (slider) {
	// Desktop: pinned phone with stacked media + stacked texts
	const mediaItems = Array.from(
		slider.querySelectorAll('[data-slide-media]'),
	);
	const textItems = Array.from(slider.querySelectorAll('[data-slide-text]'));
	// Mobile: regular stacked sections
	const mobileSlides = Array.from(slider.querySelectorAll('.tbn-slide'));

	const desktopQuery = window.matchMedia('(min-width: 992px)');
	let activeIndex = 0;

	const playVideo = (wrap) => {
		const video = wrap && wrap.querySelector('video');
		if (video && video.paused) {
			video.play().catch(() => {});
		}
	};

	const pauseVideo = (wrap) => {
		const video = wrap && wrap.querySelector('video');
		if (video && !video.paused) {
			video.pause();
		}
	};

	// Crossfade the media inside the pinned phone and the text next to it
	const setActiveSlide = (index) => {
		if (index === activeIndex) {
			return;
		}
		pauseVideo(mediaItems[activeIndex]);
		mediaItems[activeIndex].classList.remove('is-active');
		textItems[activeIndex].classList.remove('is-active');
		activeIndex = index;
		mediaItems[activeIndex].classList.add('is-active');
		textItems[activeIndex].classList.add('is-active');
		playVideo(mediaItems[activeIndex]);
	};

	// Pick the active slide from the scroll progress of the wrapper.
	// The viewport is shorter than the screen and sticks centered, so the
	// pin runs from rect.top = stickyTop until the wrapper bottom passes.
	const viewport = slider.querySelector('.tbn-slider__viewport');
	const progressFills = Array.from(
		slider.querySelectorAll('[data-progress-fill]'),
	);

	// Story-style segments: passed ones are full, the active one fills up
	// with the scroll progress inside its share of the pin.
	const setSegmentProgress = (index, innerProgress) => {
		progressFills.forEach((fill, i) => {
			let scale = 0;
			if (i < index) {
				scale = 1;
			} else if (i === index) {
				scale = innerProgress;
			}
			fill.style.transform = `scaleX(${scale})`;
		});
	};

	const updateFromScroll = () => {
		const rect = slider.getBoundingClientRect();
		const viewportHeight = viewport
			? viewport.offsetHeight
			: window.innerHeight;
		const stickyTop = Math.max(
			0,
			(window.innerHeight - viewportHeight) / 2,
		);
		const scrollable = slider.offsetHeight - viewportHeight;
		if (scrollable <= 0) {
			return;
		}
		const progress = Math.min(
			Math.max((stickyTop - rect.top) / scrollable, 0),
			1,
		);
		const exact = progress * mediaItems.length;
		const index = Math.min(mediaItems.length - 1, Math.floor(exact));
		setActiveSlide(index);
		setSegmentProgress(index, Math.min(exact - index, 1));
	};

	const onScroll = () => {
		updateFromScroll();
	};

	// Mobile: play each stacked slide's video while it is on screen
	const mobileObserver = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					playVideo(entry.target);
				} else {
					pauseVideo(entry.target);
				}
			});
		},
		{ threshold: 0.35 },
	);

	const enableDesktop = () => {
		mobileSlides.forEach((slide) => {
			mobileObserver.unobserve(slide);
			pauseVideo(slide);
		});
		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', onScroll, { passive: true });
		updateFromScroll();
		playVideo(mediaItems[activeIndex]);
	};

	const enableMobile = () => {
		window.removeEventListener('scroll', onScroll);
		window.removeEventListener('resize', onScroll);
		pauseVideo(mediaItems[activeIndex]);
		mobileSlides.forEach((slide) => mobileObserver.observe(slide));
	};

	const applyMode = () => {
		if (desktopQuery.matches) {
			enableDesktop();
		} else {
			enableMobile();
		}
	};

	desktopQuery.addEventListener('change', applyMode);
	applyMode();
}
